import { Col, Row } from '@design-system/components/grid/grid';
import { TextInput } from '../../../promotions/view/components/TextInput';
import { wrapper } from '../pdf/form.css';
import { BannerImage } from '../components/BannerImage';
import { Errors } from '@client/new/pages/promotions/view/components/Errors';
import { Button } from '@design-system/components/button/button';
import { ExtrasFormHeader } from '../components/ExtrasFormHeader';
import { LinkViewModel } from './link.viewModel';
import { ContentLink } from '../model/extras.domain';

type LinkFormProps = {
  linkVM: LinkViewModel;
  onSubmit: () => void;
};

export const LinkForm = ({ linkVM, onSubmit }: LinkFormProps) => {
  const { register, values, errors, onChange, mode } = linkVM;

  const content: ContentLink = {
    type: 'ContentLink',
    value: linkVM.content,
  };

  return (
    <div>
      <Col data-testid="ContentLinkForm" gap="xl" className={wrapper}>
        <Row>
          <Col>
            <ExtrasFormHeader content={content} />
          </Col>
          {mode === 'create' && (
            <Col style={{ width: '100px' }}>
              <Button color="neutral" onClick={onSubmit}>
                Create
              </Button>
            </Col>
          )}
        </Row>
        <Errors data={errors} />

        <div data-testid="link-url-input">
          <TextInput label="Link" {...register('url')} required />
        </div>
        <div data-testid="link-title-input">
          <TextInput
            label="Title"
            description="This title will be shown to your users"
            {...register('title')}
            required
          />
        </div>

        <BannerImage
          imageUrl={values.coverImage}
          onChange={(url) => {
            onChange('coverImage', url);
          }}
        />
      </Col>
    </div>
  );
};
